import React, { cloneElement } from "react";
import "../../styles/Project.css";
import { FaHashtag } from "react-icons/fa";
import { TagColors } from "../../data/general";
const TagItem = ({
  title,
  id,
  lblClass = "w-10 py-3",
  containerClass = "",
  checked,
  onChange,
  index,
  count,
  icon,
}) => {
  const { secondColor, mainColor } = TagColors[index] ?? {};
  return (
    <div className={`${containerClass} `}>
      <input
        type="checkbox"
        id={id}
        className="appearance-none hidden w-full h-full toggle-tag "
        onChange={onChange}
        checked={checked}
      />
      <label
        style={{ backgroundColor: checked && secondColor }}
        htmlFor={id}
        className={`flex items-center font-medium
              w-full ${lblClass} bg-transparent cursor-pointer rounded-xl overflow-hidden pl-2 pr-2`}
      >
        <span
          style={{ backgroundColor: secondColor }}
          className=" w-10 h-10 flex justify-center items-center rounded-xl  mr-1 "
        >
          {icon ? (
            cloneElement(icon, {
              size: 20,
              color: mainColor,
            })
          ) : (
            <FaHashtag color={mainColor} size={20} />
          )}
        </span>

        <div className="flex flex-col">
          <span className="text-sm text-custom-gray-900 pl-1 font-bold">
            {title}
          </span>
          <span className="text-xs text-custom-gray-600 pl-1">
            Used {count} times
          </span>
        </div>
      </label>
    </div>
  );
};

export default TagItem;
